module.exports = __webpack_public_path__ + "static/media/pic2.22b11b02.jpg";